<template>
  <section class="upload-section mt-2">
    <el-upload
      drag
      action="#"
      multiple
      :headers="uploadHeaders"
      :accept="accept"
      :on-change="handleChange"
      :auto-upload="false"
      :file-list="fileList"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
      <span class="fs-11px"><i class="el-icon-info"></i> Files must be 10mb or less</span>
    </el-upload>
    <div v-if="isUploading" class="upload-progress">
      Uploading: {{ uploadPercentage }}%
    </div>
    <div class="d-flex gap-5 mt-1">
      <el-button @click="closeDialog">Cancel</el-button>
      <el-button type="primary" @click="submitFile">Submit</el-button>
    </div>
  </section>
</template>

<script>
import commsFileUpload from '@/mixins/accred-file-upload';

export default {
  mixins: [commsFileUpload],
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    submitFile() {
      this.$emit('input', false);
      this.$emit('fileUploaded', this.fileList);
    },
    closeDialog() {
      this.$emit('closeDialog');
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.upload-progress {
  margin-top: 10px;
  font-size: 14px;
  color: #409EFF;
}
</style>
